
import React from 'react';

interface AttendancePaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  startIndex: number;
  endIndex: number;
  totalRecords: number;
  allRecordsCount: number;
}

const AttendancePagination: React.FC<AttendancePaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  startIndex,
  endIndex,
  totalRecords,
  allRecordsCount
}) => {
  return (
    <div className="px-3 py-2 border-t border-gray-200">
      <div className="flex items-center justify-between text-xs text-gray-700">
        <div>
          Showing <span className="font-medium">{totalRecords === 0 ? 0 : startIndex + 1}</span> to{' '}
          <span className="font-medium">{Math.min(endIndex, totalRecords)}</span> of{' '}
          <span className="font-medium">{totalRecords}</span> records
          <span className="ml-2 text-gray-500">(Total in cache: {allRecordsCount})</span>
        </div>
        <div className="flex items-center space-x-1">
          <button
            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            className={`px-2 py-1 border border-gray-300 rounded text-xs hover:bg-gray-50 ${
              currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            Prev
          </button>

          {Array.from({ length: totalPages }).map((_, idx) => {
            const page = idx + 1;
            if (totalPages > 7) {
              if (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 && page <= currentPage + 1)
              ) {
                return (
                  <button
                    key={page}
                    onClick={() => onPageChange(page)}
                    className={`px-2 py-1 rounded text-xs ${
                      currentPage === page
                        ? 'bg-primary-600 text-white'
                        : 'border border-gray-300 hover:bg-gray-50'
                    }`}
                  >
                    {page}
                  </button>
                );
              }
              if (page === 2 && currentPage > 3) {
                return <span key={'dots-left'} className="px-2">...</span>;
              }
              if (page === totalPages - 1 && currentPage < totalPages - 2) {
                return <span key={'dots-right'} className="px-2">...</span>;
              }
              return null;
            }
            return (
              <button
                key={page}
                onClick={() => onPageChange(page)}
                className={`px-2 py-1 rounded text-xs ${
                  currentPage === page
                    ? 'bg-primary-600 text-white'
                    : 'border border-gray-300 hover:bg-gray-50'
                }`}
              >
                {page}
              </button>
            );
          })}

          <button
            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            className={`px-2 py-1 border border-gray-300 rounded text-xs hover:bg-gray-50 ${
              currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default AttendancePagination;
